<template>
	<c-dialog ref="dialog" mode="slide" width="1000" :button="false">
		<div class="m-log-content">
			<div v-if="productInfo" class="m-log-head">{{productInfo}}</div>
			<c-title>推送记录</c-title>
			<c-table ref="list" border :paging="false">
				<c-table-column label="推送渠道" name="channel_name" width="130"></c-table-column>
				<c-table-column label="推送价格" width="110">
					<template #default="{data}">
						<span style="color: #e53e3e;">{{formatPrice(data.push_price)}}</span>
					</template>
				</c-table-column>
				<c-table-column label="推送状态" width="100">
					<template #default="{data}">
						<c-state dict="salePushStateDic" :value="data.push_state"></c-state>
					</template>
				</c-table-column>
				<c-table-column label="失败原因" name="fail_reason" width="460"></c-table-column>
				<c-table-column label="推送时间" name="create_date" width="150"></c-table-column>
			</c-table>
		</div>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'salePushLog',

		computed: {
			...mapState(['salePushStateDic'])
		},

		data() {
			return {
				productInfo: ''
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data) {
				this.productInfo = data.product_info || data.produce_unique_code || '';
				this.$refs.dialog.open({title: '推送记录'});
				this.$nextTick(() => {
					this.$refs.list.load({
						url: '/sale/push/listByProduct',
						data: {
							product_id: data.id
						}
					});
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-log-content {
		padding: 20px;
	}

	.m-log-head {
		padding: 10px 0 16px;
		font-size: 18px;
		font-weight: 600;
		color: #333;
		text-align: center;
	}
</style>
